'use client';
import InternalAnchor from './Anchor';
import AnchorLink from './AnchorLink';
const Anchor = InternalAnchor;
Anchor.Link = AnchorLink;
export default Anchor;
